import { Input } from "@/modern/components/ui/input";
import { Loader2, PlusIcon } from "lucide-react";
import { Button } from "@/modern/components/ui/button";
import { useState } from "react";
import { useEntityChecklistContext } from "../context/EntityChecklistContext";

export const ChecklistItemAddForm = () => {
  const [newItem, setNewItem] = useState("");
  const { createChecklistItem, selectedChecklist, canEditSelectedChecklist, newChecklist, persistNewChecklist, isCreatingNewChecklist } = useEntityChecklistContext();

  const [isLoading, setIsLoading] = useState(false);
  const checklist = newChecklist || selectedChecklist;
  const isDisabled = isCreatingNewChecklist || checklist?.isPhantom || isLoading || !canEditSelectedChecklist
  if (!checklist) return null;

  const handleAddItem = async (e: React.FormEvent) => {
    e.preventDefault();
    if (newChecklist) {
      setIsLoading(true);
      await persistNewChecklist();
      setIsLoading(false);
    }
    createChecklistItem(checklist, newItem);
    setNewItem("");
  };

  return (
    <form className="flex gap-2" onSubmit={handleAddItem}>
      <Input value={newItem} onChange={(e) => setNewItem(e.target.value)} placeholder="Add new item..." className="flex-1" disabled={isDisabled} />
      <Button disabled={isDisabled || !newItem} type="submit" size="icon" className="rounded-md h-full min-w-11">
        {isLoading ? <Loader2 className="size-4 animate-spin" /> : <PlusIcon className="h-10 w-10" />}
      </Button>
    </form>
  );
};
